import React, { useState, useEffect } from 'react';
import { API_ENDPOINTS, getImageUrl } from '../config/api';

const Hero = () => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadGalleryImages();
  }, []);

  useEffect(() => {
    if (galleryImages.length > 0) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === galleryImages.length - 1 ? 0 : prevIndex + 1
        );
      }, 5000); // Change image every 5 seconds

      return () => clearInterval(interval);
    }
  }, [galleryImages]);

  const loadGalleryImages = async () => {
    try {
      const response = await fetch(API_ENDPOINTS.GALLERY);
      if (response.ok) {
        const data = await response.json();
        // Filter for active images only and take first 6 for slideshow
        const activeImages = data.filter(item => item.isActive && item.fileType === 'image').slice(0, 6);
        setGalleryImages(activeImages);
      }
    } catch (error) {
      console.error('Error loading gallery images:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Images Slideshow */}
      {galleryImages.length > 0 && (
        <div className="absolute inset-0">
          {galleryImages.map((image, index) => (
            <div
              key={image.id}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentImageIndex ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img
                src={getImageUrl(image.filePath)}
                alt={image.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black bg-opacity-40"></div>
            </div>
          ))}
        </div>
      )}

      {/* Fallback background if no images */}
      {galleryImages.length === 0 && !loading && (
        <div className="absolute inset-0 bg-gradient-to-br from-primary via-blue-600 to-blue-800"></div>
      )}

      {/* Content */}
      <div className="relative z-10 text-center text-white px-6 max-w-4xl mx-auto">
        <div className="animate-fade-in-up">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 drop-shadow-lg">
            Creative Town
            <span className="block text-3xl md:text-5xl font-medium mt-2">
              Bilingual School
            </span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 drop-shadow-md font-light">
            Citadel of Success, Core Care and Education
          </p>

          {/* Call to Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <a
              href="/enrollment"
              className="bg-green-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-green-700 transition duration-300 transform hover:scale-105 shadow-lg"
            >
              Enroll Now
            </a>
            <a
              href="#about"
              className="bg-white text-primary px-8 py-3 rounded-full font-semibold hover:bg-opacity-90 transition duration-300 transform hover:scale-105 shadow-lg"
            >
              Learn More About Us
            </a>
            <a
              href="/student-login"
              className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-primary transition duration-300 transform hover:scale-105 shadow-lg"
            >
              Student Portal
            </a>
          </div>

          {/* School Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-2xl mx-auto">
            <div className="bg-white bg-opacity-20 backdrop-blur-sm rounded-lg p-4">
              <div className="text-2xl md:text-3xl font-bold">50+</div>
              <div className="text-sm">Happy Students</div>
            </div>
            <div className="bg-white bg-opacity-20 backdrop-blur-sm rounded-lg p-4">
              <div className="text-2xl md:text-3xl font-bold">15+</div>
              <div className="text-sm">Expert Teachers</div>
            </div>
            <div className="bg-white bg-opacity-20 backdrop-blur-sm rounded-lg p-4">
              <div className="text-2xl md:text-3xl font-bold">1+</div>
              <div className="text-sm">Years Experience</div>
            </div>
            <div className="bg-white bg-opacity-20 backdrop-blur-sm rounded-lg p-4">
              <div className="text-2xl md:text-3xl font-bold">100%</div>
              <div className="text-sm">Success Rate</div>
            </div>
          </div>

          {/* Achievement Message */}
          <div className="mt-8 max-w-3xl mx-auto">
            <p className="text-lg md:text-xl text-center leading-relaxed bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-6 border border-white border-opacity-20">
              <span className="font-semibold text-yellow-300">Remarkable Achievement:</span> Despite being a young institution with just over a year of experience,
              Creative Town Bilingual School has already established itself as a beacon of educational excellence,
              achieving outstanding results that surpass expectations for schools of our age.
            </p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>

      {/* ? State */}
      {loading && (
        <div className="absolute inset-0 bg-primary flex items-center justify-center">
          <div className="text-center text-white">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-white mb-4"></div>
            <p className="text-lg">Loading Creative Town...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Hero;



